"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import API from "@ym-framework/api-utils";
import axios from "axios";
import { WebsocketService } from "@/utils/webSocketService";
import {
  MAIN_WEBSOCKET,
  WEB_HTML,
  SESSION_URL
} from "@/configuration/websocketskey";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import ProgressComponent from "@/components/progress/Progress.vue";
import DownloadTipDialog from "./DownloadTipDialog.vue";
import NoticeDialog from "@/components/layout/components/dialog/NoticeDialog.vue";
import BlockDialog from "@/components/layout/components/dialog/BlockDialog.vue";
const contact_us = require("../../assets/img/contact_us.png");
const kefuWechatUrl = require("../../assets/img/kefu_wechat.png");
const kefuQQUrl = require("../../assets/img/kefu_qq.png");
const kefu400Url = require("../../assets/img/kefu_400.png");
const kefuWechatQrcodeUrl = require("../../assets/img/wechat_qrcode.png");
let HomePage = class extends Vue {
  constructor() {
    super(...arguments);
    this.webSocketService = new WebsocketService(MAIN_WEBSOCKET);
    this.webSocketViewService = WebsocketViewService;
    this.isLogin = false;
    this.showLock = false;
    this.showUpdate = false;
    this.progress = 0;
    this.tabActive = "baidu";
    this.inputValue = "";
    this.accountName = "";
    this.downloadTip = "";
    this.downloadUrl = "";
    this.downloadVersion = "";
    this.notify = null;
    //联系我们图片
    this.contact_us = contact_us;
    // 客服微信的图片地址
    this.kefuWechatUrl = kefuWechatUrl;
    //客服QQ的图片地址
    this.kefuQQUrl = kefuQQUrl;
    //客服电话的图片地址
    this.kefu400Url = kefu400Url;
    // 客服微信二维码图片地址
    this.kefuWechatQrcodeUrl = kefuWechatQrcodeUrl;
    // 子账号是否显示快速入口
    this.showQuickJump = false;
    this.web_html = `${WEB_HTML}/auth_login`;
  }
  created() {
    return __async(this, null, function* () {
      this.webSocketService.run();
      this.webSocketService.on(
        "event:pageEvent.login.success",
        (data) => __async(this, null, function* () {
          yield this.getLoginMessage();
        })
      );
      this.webSocketService.on(
        "event:pageEvent.logout.success",
        (data) => __async(this, null, function* () {
          this.showQuickJump = true;
          this.isLogin = false;
        })
      );
    });
  }
  mounted() {
    return __async(this, null, function* () {
      var _a;
      document.body.style.minWidth = "970px";
      this.webSocketViewService._ipcEvent.on(
        "event:update.auto.download",
        (data) => __async(this, null, function* () {
          this.updateStart();
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:update.need.download",
        (data) => __async(this, null, function* () {
          if (!sessionStorage.getItem("updata_message_notify")) {
            this.downloadTip = data.tip;
            this.downloadUrl = data.url;
            this.downloadVersion = data.last;
            this._download_tip_dialog.open();
          }
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:update.need.install",
        (data) => __async(this, null, function* () {
          this.installStart();
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:pageEvent.start.install",
        (data) => __async(this, null, function* () {
          this.updateStart();
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:pageEvent.close.notification",
        (data) => __async(this, null, function* () {
          this.closeNotify();
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:pageEvent..success",
        (data) => __async(this, null, function* () {
          yield this.getLoginMessage();
        })
      );
      let html = document.querySelector("html");
      if (html) {
        html.style.margin = "0";
        html.style.padding = "0";
        html.style.fontSize = "16px";
        html.style.height = "auto";
        html.style.fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;";
        html.style.backgroundColor = "#f9f9f9";
      }
      let app = document.querySelector("#app");
      if (app) {
        app.style.margin = "0";
        app.style.padding = "0";
        app.style.fontSize = "16px";
        app.style.height = "auto";
        app.style.fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;";
        app.style.backgroundColor = "#f9f9f9";
      }
      try {
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(
          `${SESSION_URL}/v1/account/session`,
          {
            headers: {
              Authorization: _token,
              "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
            }
          }
        );
        const session = session_response.data;
        if (session.type === "account") {
          this.showQuickJump = true;
        } else {
          this.showQuickJump = false;
        }
        this.accountName = `${session.name}(${session.account})`;
        this.isLogin = true;
      } catch (error) {
        this.showQuickJump = true;
        this.isLogin = false;
      }
    });
  }
  openNotice() {
    return __async(this, null, function* () {
      try {
        yield API.get(
          `api://base.local/storages/preference/core_upgrade_notice_new`
        );
      } catch (error) {
        this._notice_dialog.open();
      }
    });
  }
  updateStart() {
    if (this.showUpdate === true) {
      return;
    }
    this.showUpdate = true;
    const h = this.$createElement;
    this.notify = this.$notify({
      title: this.$t("homepage.downloading"),
      dangerouslyUseHTMLString: true,
      duration: 0,
      message: h(ProgressComponent)
    });
  }
  installStart() {
    if (this.showLock === true) {
      return;
    }
    this.showLock = true;
    if (sessionStorage.getItem("install_message_notify")) {
      return;
    }
    const h = this.$createElement;
    const notify = this.$notify({
      title: this.$t("homepage.installing"),
      duration: 0,
      message: h("div", {}, [
        h(
          "el-button",
          {
            props: { type: "text" },
            on: {
              click: this.startInstall
            }
          },
          this.$t("homepage.start_install")
        ),
        h(
          "el-button",
          {
            props: { type: "text" },
            style: "color:#c0c4d4",
            on: {
              click: () => {
                this.installNextTime();
                notify.close();
              }
            }
          },
          this.$t("homepage.next_time")
        )
      ])
    });
  }
  installNextTime() {
    return __async(this, null, function* () {
      sessionStorage.setItem("install_message_notify", "show");
      yield API.put(`api://base.local/storages/session/updateInstall`, {
        message: "no.need.install",
        model: "no.need.install"
      });
    });
  }
  startInstall() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/update/install`);
      } catch (error) {
        console.log(error);
      }
    });
  }
  closeNotify() {
    this.notify.close();
    this.notify = null;
  }
  getLoginMessage() {
    return __async(this, null, function* () {
      var _a;
      try {
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(
          `${SESSION_URL}/v1/account/session`,
          {
            headers: {
              Authorization: _token,
              "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
            }
          }
        );
        const session = session_response.data;
        if (session.type === "account") {
          this.showQuickJump = true;
        } else {
          this.showQuickJump = false;
        }
        this.accountName = `${session.name}(${session.account})`;
        this.isLogin = true;
      } catch (error) {
        this.showQuickJump = true;
        this.isLogin = false;
      }
    });
  }
  searchInput() {
    return __async(this, null, function* () {
      try {
        if (this.tabActive === "baidu") {
          let href = `https://www.baidu.com/s?wd=${this.inputValue}&t=kjvs`;
          window.open(href, "_self");
        }
        if (this.tabActive === "us_amazon") {
          let href = `https://www.amazon.com/s?k=${this.inputValue}`;
          window.open(href, "_self");
        }
        if (this.tabActive === "en_amazon") {
          let href = `https://www.amazon.co.uk/s?k=${this.inputValue}`;
          window.open(href, "_self");
        }
        if (this.tabActive === "jp_amazon") {
          let href = `https://www.amazon.co.jp/s?k=${this.inputValue}`;
          window.open(href, "_self");
        }
        if (this.tabActive === "de_amazon") {
          let href = `https://www.amazon.de/s?k=${this.inputValue}`;
          window.open(href, "_self");
        }
        if (this.tabActive === "google") {
          let href = `https://www.google.com/search?q=${this.inputValue}`;
          window.open(href, "_self");
        }
      } catch (error) {
      }
    });
  }
  openShopManager() {
    if (this.isLogin) {
      window.open(`${WEB_HTML}/`, "_self");
    }
    if (!this.isLogin) {
      window.open(`${WEB_HTML}/auth_login`, "_self");
    }
  }
  openBuyVD() {
    if (this.isLogin) {
      window.open(`${WEB_HTML}/payment?style=create`, "_self");
    }
    if (!this.isLogin) {
      window.open(`${WEB_HTML}/auth_login?page=payment?style=create`, "_self");
    }
  }
  openTeamManager() {
    if (this.isLogin) {
      window.open(`${WEB_HTML}/to_manager`, "_self");
    }
    if (!this.isLogin) {
      window.open(`${WEB_HTML}/auth_login?page=to_manager`, "_self");
    }
  }
  openCloudNumber() {
    if (this.isLogin) {
      window.open(`https://yunhao.kuajingvs.com/`, "_self");
    }
    if (!this.isLogin) {
      window.open(`${WEB_HTML}/auth_login?page=yunhao`, "_self");
    }
  }
  openRPA() {
    if (this.isLogin) {
      window.open(`https://rpa.kuajingvs.com/`, "_self");
    }
    if (!this.isLogin) {
      window.open(`${WEB_HTML}/auth_login?page=rpa`, "_self");
    }
  }
  //前往联系我们
  toConnectUs() {
    window.open("https://wpa1.qq.com/FzfSmq8R?_type=wpa&qidian=true", "_blank");
  }
  beforeDestroy() {
    this.webSocketViewService._ipcEvent.removeAllListeners();
  }
};
__decorateClass([
  Ref("noticeDialog")
], HomePage.prototype, "_notice_dialog", 2);
__decorateClass([
  Ref("blockDialog")
], HomePage.prototype, "_block_dialog", 2);
__decorateClass([
  Ref("download_tip_dialog")
], HomePage.prototype, "_download_tip_dialog", 2);
__decorateClass([
  Debounce(500)
], HomePage.prototype, "getLoginMessage", 1);
__decorateClass([
  Debounce(500)
], HomePage.prototype, "searchInput", 1);
HomePage = __decorateClass([
  Component({
    components: {
      ProgressComponent,
      DownloadTipDialog,
      NoticeDialog,
      BlockDialog
    }
  })
], HomePage);
export {
  HomePage as default
};
